
define('text!views/Reporting/RAInherentReport.html',[],function () { return '<section class="content-header">\r\n    <h1>Inherent Risk Heatmap</h1>\r\n</section>\r\n<!--<section class="content container-fluid">\r\n        <div class="box">-->\r\n            <div id="div_RA_Inherent_Report" style="display: block; width: 100%; height:100%"></div>\r\n    <!--</div>\r\n</section>-->';});

